import { DataTableColumnDef } from "@/components/molecules";
import { MonthlyInvoiceTableData } from "./types";
import { MonthlyInvoiceItem } from "@/redux/slices/payment/types";
import { format } from "date-fns";
import { formatCurrency } from "@/utils";
import { IconButton } from "@/components/atoms";

export const generateColumns = () => {
  const columns: DataTableColumnDef<MonthlyInvoiceTableData>[] = [
    {
      accessorKey: "rideMinderInvoices",
      header: "RideMinder Invoices",
      cell: (props) => props.row.original.rideMinderInvoices,
      enableSorting: false,
    },
    {
      accessorKey: "dateIssued",
      header: "Date Issued",
      cell: (props) => props.row.original.dateIssued,
      enableSorting: false,
      size: 150,
    },
    {
      accessorKey: "total",
      header: "Total",
      cell: (props) => props.row.original.total,
      enableSorting: false,
      size: 150,
    },
    {
      accessorKey: "pdf",
      header: "PDF",
      cell: (props) => props.row.original.pdf,
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "csv",
      header: "CSV",
      cell: (props) => props.row.original.csv,
      enableSorting: false,
      size: 80,
    },
  ];

  return columns;
};

export const generateData = (items: MonthlyInvoiceItem[], dateFormat: string, onDownload: (id: string, documentType: string) => void) => {
  const data = items.map(
    (i) =>
      ({
        rideMinderInvoices: i.invoiceMonth,
        dateIssued: format(new Date(i.issueDate), dateFormat),
        total: formatCurrency(i.amount, 2, i.currency),
        pdf: <IconButton variant="custom" iconSize="lg" iconName="ImportCurve" onClick={() => onDownload(i.id, "pdf")} />,
        csv: <IconButton variant="custom" iconSize="lg" iconName="ImportCurve" onClick={() => onDownload(i.id, "csv")} />,
      } as MonthlyInvoiceTableData)
  );

  return data;
};